import { IichiEnv } from './_env';

export const CdnDomain = {
  [IichiEnv.DEV]: 'http://localhost',
  [IichiEnv.STAGE]: 'https://cdn.iichi-dev.com',
  [IichiEnv.PROD]: 'https://cdn.iichi.com',
} as const satisfies Record<IichiEnv, string>;
export type CdnDomain = (typeof CdnDomain)[keyof typeof CdnDomain];
